import { type AxiosRequestConfig } from 'axios'
import { type IUser } from '../server/user/get'

const updateUser = (data: IUser): AxiosRequestConfig => {
  return {
    method: 'PUT',
    url: '/user',
    data,
  }
}

export { updateUser }
